module.exports = __webpack_public_path__ + "img/holdings--icon.b01b871a.svg";